/**
 * Compact integer formatting for usage/billing surfaces.
 *
 * Big counts (tokens, points) are hard to read as full digit strings
 * ("1,245,238"). We collapse thousands to a lowercase "k" suffix while KEEPING
 * comma grouping on the value, so 1,245,238 → "1,245k" (not "1.2M"). Lowercase
 * "k" is the SI-correct kilo symbol (uppercase "K" is Kelvin). House style:
 * uniform k, grouped, no decimals.
 *
 *   < 1000        → the number, grouped ("842")
 *   ≥ 1000        → round to thousands, grouped, + "k" ("1,245k")
 *   null / NaN    → "—" (honest empty, never "0")
 *
 * Values 1000–999,999 also collapse (e.g. 12,500 → "13K"), which is the point:
 * one consistent rule across every count. Callers that must show exact digits
 * (an invoice line, a CSV export) should NOT use this — use toLocaleString().
 */
export function formatCompactNumber(n) {
  if (n == null || Number.isNaN(Number(n))) return '—';
  const v = Number(n);
  const neg = v < 0 ? '-' : '';
  const abs = Math.abs(v);
  if (abs < 1000) return `${neg}${Math.round(abs).toLocaleString()}`;
  const k = Math.round(abs / 1000);
  return `${neg}${k.toLocaleString()}k`;
}
